module.exports = __webpack_public_path__ + "img/newspapers_button_left_down.c1d6f256.png";